import { render } from "./LoadingOverlay.vue?vue&type=template&id=0c970e2c&scoped=true"
const script = {}

import "./LoadingOverlay.vue?vue&type=style&index=0&id=0c970e2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c970e2c"]])

export default __exports__